if (!Array.from) {
  Array.from = (function () {
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // The length property of the from method is 1.
    return function from(arrayLike/*, mapFn, thisArg */) {
      // 1. Let C be the this value.
      var C = this;

      // 2. Let items be ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. ReturnIfAbrupt(items).
      if (arrayLike == null) {
        throw new TypeError("Array.from requires an array-like object - not null or undefined");
      }

      // 4. If mapfn is undefined, then let mapping be false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }

        // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }());
}

!(function ($) {
    $.fn.eqHeight = function ($bounds) {
        $('.ie .feed-continuous .slide').find('img').removeClass('pa');

        var $els     = $(this);
        var elLength = $els.length;
        var $bounds  = $bounds || $els.parent();

        if (typeof ($bounds) === "number") {
            cols = $bounds;
        } else {
            var containerWidth = $bounds.width(),
                boxWidth = $els.eq(0).width(),
                cols = Math.floor(containerWidth / boxWidth);
        }

        var height, i, l, j;

        if (cols > 1) {
            $els.css({ height: 'auto', minHeight: 0 });

            for (i = 0, l = elLength; i < l; i += cols) {
                height = 0;

                for (j = 0; j < cols; j++) {
                    if ($els.eq(i + j).length) {
                        height = Math.max(height, $els.eq(i + j).outerHeight());
                    }
                }

                height = Math.ceil(height);

                for (j = 0; j < cols; j++) {
                    $els.eq(i + j).height(height);
                }
            }
        }

        return $els;
    };

    $.fn.scale = function (type = 'contain') {
        const $this = $(this);

        const TYPES = {
            contain: function () {
                const $this = $(this);
                const $bounds = $this.parent();

                TweenMax.set($bounds, { height: 'auto' });
                TweenMax.set($this, { scale: 1 });

                const size = {
                    w: $this.innerWidth(),
                    h: $this.innerHeight(),
                };

                const bounds = {
                    w: $bounds.innerWidth(),
                    h: $bounds.innerHeight(),
                };

                let scale = 1;

                if (size.w / size.h > bounds.w / bounds.h) {
                    scale = bounds.w / size.w;
                } else {
                    scale = bounds.h / size.h;
                }

                scale = scale > 1 ? 1 : scale;

                TweenMax.set($this, { scale: scale });
                TweenMax.set($bounds, { height: size.h * scale });

                $this.find('[data-fullheight]').each(function () {
                    const $this = $(this);

                    $this.removeAttr('style');

                    const height = $this.height();

                    console.log(height, scale, height / scale / scale);

                    TweenMax.set($this, { height: height / scale / scale });
                });

                $this.data('scale', scale);
            },

            width: function () {
                const $this = $(this);
                const $bounds = $this.parent();

                TweenMax.set($bounds, { height: 'auto' });
                TweenMax.set($this, { scale: 1 });

                const size = {
                    w: $this.innerWidth(),
                    h: $this.innerHeight(),
                };

                const bounds = {
                    w: $bounds.innerWidth(),
                    h: $bounds.innerHeight(),
                };

                scale = bounds.w / size.w;

                TweenMax.set($this, { scale: scale });
                TweenMax.set($bounds, { height: size.h * scale });

                $this.find('[data-fullheight]').each(function () {
                    const $this = $(this);

                    $this.removeAttr('style');

                    const height = $this.height();

                    console.log(height, scale, height / scale / scale);

                    TweenMax.set($this, { height: height / scale / scale });
                });

                $this.data('scale', scale);
            },

            reset: function () {
                const $this = $(this);
                const $bounds = $this.parent();

                TweenMax.set($bounds, { height: 'auto' });
                TweenMax.set($this, { scale: 1 });

                $this.data('scale', 1);
            },
        };

        if (typeof TYPES[type] !== 'undefined') {
            $this.each(TYPES[type]);
        }
    };

    $.fn.scrolling = function (type = 'x') {
        const $this = $(this);

        const TYPES = {
            x: function () {
                const $this = $(this);
                const $items = $this.find('> *');

                let maxVelocity = 100;
                let aceleration = 2;

                let velocity = 0;

                let playing = true;
                let currentTime = 0;
                let w = Array.from($items).reduce((a, v) => a + v.clientWidth, -1);
                let x = 0;

                $window.on('resize', function () {
                    w = Array.from($items).reduce((a, v) => a + v.clientWidth, -1);

                    if (wW <= 768) {
                        maxVelocity = 100 / 2;
                        aceleration = 2 / 2;
                    } else {
                        maxVelocity = 100;
                        aceleration = 2;
                    }
                });

                $items.each(function () {
                    $(this).clone(true).addClass('scrolling-clone').appendTo($this);
                });

                $items.each(function () {
                    $(this).clone(true).addClass('scrolling-clone').appendTo($this);
                });

                const loop = (timestamp) => {
                    currentTime = currentTime == 0 ? timestamp : currentTime;

                    const dt = timestamp - currentTime;

                    if (playing) {
                        velocity += aceleration;
                        velocity = velocity > maxVelocity ? maxVelocity : velocity;
                    } else {
                        velocity -= aceleration;
                        velocity = velocity < 0 ? 0 : velocity;
                    }

                    x -= (velocity * dt / 1000).toFixed(2);
                    x = x % w;

                    TweenMax.set($this, { x: x });

                    currentTime = timestamp;

                    requestAnimationFrame(loop);
                };

                requestAnimationFrame(loop);


                $this.on('mouseenter', function () {
                    playing = false;
                });

                $this.on('mouseleave', function () {
                    playing = true;
                });
            },
        };

        if (typeof TYPES[type] !== 'undefined') {
            $this.each(TYPES[type]);
        }
    }

    $.fn.gif = function (type = 600, ...params) {
        const $this = $(this);

        const TYPES = {
            play: function (delay) {
                const $this = $(this);

                $this.gif('pause');

                const timeout = setInterval(() => {
                    $this.gif('next');
                }, delay);

                $this.data('timeout', timeout);
            },
            pause: function () {
                const $this = $(this);

                const timeout = $this.data('timeout');

                clearInterval(timeout);
            },
            next: function () {
                const $this = $(this);

                const currentFrame = $this.data('current-frame') || 0;
                $this.gif('goto', currentFrame + 1);
            },
            prev: function () {
                const $this = $(this);

                const currentFrame = $this.data('current-frame') || 0;
                $this.gif('goto', currentFrame - 1);
            },
            goto: function (currentFrame) {
                const $this = $(this);
                const $childs = $this.find('> *');

                const total = $childs.length;

                $childs.filter(':visible').hide();
                $childs.eq(currentFrame % total).show();

                $this.data('current-frame', currentFrame);
            }
        };

        if (typeof TYPES[type] !== 'undefined') {
            $this.each(function () { TYPES[type].call(this, ...params); });
        } else {
            $this.each(function () { TYPES['play'].call(this, type); });
        }
    };
})(jQuery);

function heightElements() {
    // $('.scaled').scale('reset');
    $('.pop-wrap').scale('reset');

    const peopleitem = '.people-slider .owl-item';
    const col4       = '.card-list .col-sm-4';
    const col6       = '.card-list .col-sm-6';
    const col3       = '.col-sm-3';
    const colslider  = '.slider .slide';

    $('.card-list').each(function () {
        $(this).find(colslider + ' p').eqHeight($(colslider).length);
        $(this).find(colslider + ' figure').eqHeight($(colslider).length);
        $(this).find(colslider).eqHeight($(colslider).length);
    });

    const $peopleSlider = $('.people-slider');
    const $testimonialSlider = $('.testimonial-slider');

    if (wW > 768) {
        if ($peopleSlider.hasClass('owl-loaded')) {
            $peopleSlider.owlCarousel('destroy');
        }

        if ($testimonialSlider.hasClass('owl-loaded')) {
            $testimonialSlider.owlCarousel('destroy');
        }

        $(peopleitem).find('figure').eqHeight(3);
        $(peopleitem).eqHeight(3);

        $(col4).find('figure').eqHeight(3);
        $(col4).eqHeight(3);

        if ($('.feed-list').length > 0) {
            $(col6).slice(1).find('figure').eqHeight(2);
        } else {
            $(col6).find('figure').eqHeight(2);
        }
        $(col6).eqHeight(2);

        $('.card-list').each(function () {
            $(this).find(col3 + ' figure').eqHeight(4);
            $(this).find(col3).eqHeight(4);
        });

        setTimeout(() => {
            $('.ie .feed-continuous .slide').find('img').addClass('pa');
        }, 300);
        // $('.scaled').scale('contain');
        // $('.pop-wrap').scale('contain');

    } else {
        if (!$peopleSlider.hasClass('owl-loaded')) {
            $peopleSlider.owlCarousel({
                center: true,
                items: 1,
                dots: true,
                nav: false,
                responsive: {
                    769: {
                        dots: false,
                        loop: false,
                        items: 3
                    }
                }
            });
        }

        if (!$testimonialSlider.hasClass('owl-loaded')) {
            $testimonialSlider.owlCarousel({
                center: true,
                items: 1,
                loop: true,
                dots: true,
                nav: false,
                responsive: {
                    769: {
                        items: 3
                    }
                }
            });
        }

        $(col4).removeAttr('style').find('figure').removeAttr('style');
        $(col6).removeAttr('style').find('figure').removeAttr('style');
        $(col3).removeAttr('style').find('figure').removeAttr('style');

        // $('.scaled').scale('width');
        // $('.pop-wrap').scale('width');
    }
}

const $window   = $(window);
const $document = $(document);
const $body     = $('body');
const $mainMenu = $('#main-menu');

const lang      = $('html').attr('lang');

let wW          = $window.outerWidth();
let wH          = $window.outerHeight();
let dH          = $document.outerHeight();
let canScroll;
let scrollPos = $window.scrollTop();
let scrollAni = false;

if (Is.mobile.ANY()) {
    $body.addClass('mobile');
} else {
    $body.addClass('desktop');
}

if (Is.desktop.MAC()) {
    $body.addClass('mac');
}

if(Is.desktop.IE()) {
    $body.addClass('ie');
}

if(Is.desktop.IE10()) {
    $body.addClass('ie10');
}

if(Is.desktop.IE11()) {
    $body.addClass('ie11');
}

if(Is.desktop.EDGE()) {
    $body.addClass('edge');
}

if(Is.desktop.CHROME()) {
    $body.addClass('chrome');
}

if(Is.desktop.FIREFOX()) {
    $body.addClass('firefox');
}

if(Is.desktop.SAFARI()) {
    $body.addClass('safari');
}

let hidden, visibilityState, visibilityChange;

if (typeof document.hidden !== 'undefined') {
    hidden = 'hidden', visibilityChange = 'visibilitychange', visibilityState = 'visibilityState';
} else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden', visibilityChange = 'msvisibilitychange', visibilityState = 'msVisibilityState';
}

let document_hidden = document[hidden];

$document.on('preloaded.after', function () {
    $window
        .on('scroll', function () {
            if (!Is.mobile.ANY()) {
                Animator.onScroll();
            }

            if (!Navigation._scrollingTo) {
                let $currentPage = null;

                $('[data-url]:visible').each(function () {
                    let $this = $(this);
                    let $parent = $this.parents('[data-url]');

                    if ($parent.length) {
                        if ($parent.isOnScreenPercent(.5)) {
                            $currentPage = $this;
                        }
                    } else {
                        if ($this.isOnScreenPercent(.5)) {
                            $currentPage = $this;
                        }
                    }
                });

                if ($currentPage) {
                    Navigation.setURL($currentPage.attr('data-url'), 0);
                }
            }
        })
        .trigger('scroll');

    $document.on(visibilityChange, function() {
        if (document_hidden != document[hidden]) {
            if (document[hidden]) {
                // Document hidden
            } else {
                $window.trigger('resize').trigger('scroll');
            }

            document_hidden = document[hidden];
        }
    });
});

// $document.keyup(function (event) {
//     if (event.keyCode == 37) {
//        $peopleSlider.trigger('owl.prev');
//     } else if (event.keyCode == 39) {
//        $peopleSlider.trigger('owl.next');
//     }
// });

$document.on('preloaded.before', function () {
    if (!Is.mobile.ANY()) {
        let c = new ScrollMagic.Controller();
        Timeline.setup(c);
    }

    $window
        .on('resize', function () {
            wW = $window.outerWidth();
            wH = $window.outerHeight();
            dH = $document.outerHeight();

            heightElements();

            if (!Is.mobile.ANY()) {
                $body.removeClass('mobile');
                $body.addClass('desktop');
                canScroll = true;
            } else {
                $body.removeClass('desktop');
                $body.addClass('mobile');
                canScroll = false;
            }
        })
        .on('scroll', function () {
            if (!scrollAni) {
                scrollPos = $window.scrollTop();
            }
        });

    const $spriteTrabalhosVertical = $('.sprite-trabalhos-vertical');
    $spriteTrabalhosVertical.gif('goto', 0);
    $spriteTrabalhosVertical
        .on('mouseenter', function(){
            $(this).gif('play', 250);
        })
        .on('mouseleave', function(){
            $(this).gif('pause');
        });

    const $spriteTrabalhos = $('.sprite-trabalhos');
    $spriteTrabalhos.gif('goto', 0);
    $spriteTrabalhos
        .on('mouseenter', function () {
            if (!Is.mobile.ANY()) {
                $(this).gif('play', 250);
            }
        })
        .on('mouseleave', function () {
            if (!Is.mobile.ANY()) {
                $(this).gif('pause');
            }
        });

    $spriteTrabalhos
        .on('click', function () {
            if (Is.mobile.ANY()) {
                $(this).gif('play', 250);
            }
        });

    $document
        .on('click', function (e) {
            if (Is.mobile.ANY()) {
                if ($(e.target).closest($spriteTrabalhos).length == 0) {
                    $spriteTrabalhos.gif('pause');
                }
            }
        });

    const $spriteMarcas = $('.logo-companies');
    $spriteMarcas.gif('goto', 0);
    if (Is.mobile.ANY()) {
        $('.text-companies')
            .on('click', function() {
                const $this = $(this);
                $this.toggleClass('active');
                $spriteMarcas.find('img').removeAttr('style');

                setTimeout(function() {
                    if ($this.hasClass('active')) {
                        $spriteMarcas.gif('play', 250);
                    } else {
                        $spriteMarcas.gif('pause');
                    }
                }, 200);
            });
    } else {
        $('.text-companies')
            .on('mouseenter touchstart', function(){
                $(this).addClass('active');
                $spriteMarcas.gif('play', 250);
            })
            .on('mouseleave touchend', function(){
                $(this).removeClass('active');
                $spriteMarcas.gif('pause');
            });
    }

    $('.slider-centered').owlCarousel({
        center: true,
        items: 1,
        loop: true,
        dots: false,
        nav: true,
        navText: ["←", "→"],
        responsive: {
            769: {
                items: 2,
            }
        }
    });

    const $last = $('.feed-continuous .slide').last();
    $last.remove();

    const $feedContinuous = $('.feed-continuous');

    $feedContinuous.prepend($last);
    $feedContinuous.scrolling();

    Component.init();

    if (typeof Navigation !== 'undefined') { Navigation.init(); }
    if (typeof Ticker !== 'undefined') { Ticker.init(); }

    const onPeople = (url) => {
        if (
            url != 'pt/pessoas/' && url != 'pt/pessoas/quem-somos/' &&
            url != 'en/people/' && url != 'en/people/who-we-are/'
            ) {
            Navigation.helpers.scrollTo(url);
        }
    };

    const onClients = (url) => {
        Navigation.helpers.scrollTo(url);
    };

    Navigation.on('pessoas', onPeople);
    Navigation.on('people', onPeople);

    Navigation.on('clientes', onClients);
    Navigation.on('clients', onClients);

    $window.trigger('resize').trigger('popstate');
});


$body.waitForImages(true)
    .progress((loaded, count, success) => {
        count++;

        let percent = (loaded * 100 / count);

        TweenMax.to('.preloader__bar__progress', .6, { width: percent+'%', ease: Expo.easeInOut});
    })
    .done(() => {
        TweenMax.to('.preloader__bar__progress', .6, { width: '100%', onComplete: () => {
            $document.trigger('preloaded.before');

            TweenMax.to('.preloader', .4, { opacity: 0, display: 'none', onComplete: () => $document.trigger('preloaded.after') });
        } });
    });
